module.exports = __webpack_public_path__ + "img/006岳晋琛.468b730f.png";